import React, { useState } from 'react';
import './Reviews.css';
import Loaderdots from '../../components/LoaderDots/Loaderdots';
import { avathar } from '../../Assests/Assests';


const Reviews = ({ reviews }) => {
    const [loading, setLoading] = useState(false); // Loader state
  
  return (
    <>
    <div className="reviews-container">
      <h6 className="reviews-header">Customer Reviews ({reviews.length})</h6>
      {reviews && reviews.length > 0 ? (
        <ul className="reviews-list">
          {reviews.map((review) => (
              <li key={review._id} className="reviews-item">
                <div className="review-header">
                  <img
                    src={avathar}
                    alt={`${review.userName}'s profile`}
                    className="review-profile"
                  />
                  <div className="review-info">
                    <span className="review-user">{review.userName}</span>
                    <span className="review-rating">
                      {Array.from({ length: 5 }, (_, i) => (
                        <span
                          key={i}
                          className={i < review.rating ? "star filled" : "star"}
                        >
                          ★
                        </span>
                      ))}
                    </span>
                  </div>
                </div>
                <p className="reviews-text">{review.review}</p>
              </li>
          ))}
         
        </ul>
      ) : (
       <div>{reviews.length > 0 ? <Loaderdots /> : " "}</div>
      )}
    </div>

    </>
  );
};

export default Reviews;
